import React from 'react';
import { FadeIn } from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const AFFILIATE_URL = 'https://amzn.to/46L71gr';

const pillars = [
  { icon: FiIcons.FiHome, title: "REITs", subtitle: "Immobilien", desc: "Physische Immobilienerträge ohne den Stress eines Vermieters." },
  { icon: FiIcons.FiBriefcase, title: "BDCs", subtitle: "Unternehmenskredite", desc: "Vergeben Sie Kredite wie eine Privatbank und kassieren Sie hohe Zinsen." },
  { icon: FiIcons.FiBarChart2, title: "Covered-Call-ETFs", subtitle: "Optionsstrategien", desc: "Hohe Renditen durch intelligente Optionsstrategien – automatisiert im ETF." },
];

const bullets = [
  { icon: FiIcons.FiTrendingDown, title: "Schluss mit dem Kurs-Stress", desc: "Lernen Sie, wie Sie ein Portfolio aufbauen, bei dem fallende Kurse egal sind, solange die Dividende fliesst." },
  { icon: FiIcons.FiDollarSign, title: 'Das "Zweite Gehalt" Prinzip', desc: "REITs und BDCs so kombinieren, dass Sie jeden Monat Cashflow auf dem Konto sehen." },
  { icon: FiIcons.FiZap, title: "Die Fabrik-Mentalität", desc: "Verwandeln Sie Ihr Depot in ein seriöses Unternehmen, das für Sie arbeitet, während Sie schlafen." },
  { icon: FiIcons.FiShield, title: "Steuer-Sicherheit im DACH-Raum", desc: "Kein Rätselraten bei US-Quellensteuern. Welche Formulare (W-8BEN, DA-1) Sie brauchen." },
  { icon: FiIcons.FiClock, title: "Zeitgewinn durch System", desc: "Einmal aufgebaut, benötigt dieses System weniger als 30 Minuten Pflege im Monat." },
];

function handleAmazonClick() {
  if (typeof window.trackAmazonClick === 'function') {
    window.trackAmazonClick('solution_section', 'Jetzt die Cashflow-Strategie auf Amazon sichern');
  }
}

export const Solution = () => {
  return (
    <section className="py-16 md:py-24 bg-navy text-white relative border-t-4 border-gold">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">

        <FadeIn className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-5">
            Die 3 Säulen der finanziellen Freiheit
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-5"></div>
          <p className="font-sans text-gray-300 text-base md:text-lg">
            Wahre finanzielle Freiheit entsteht durch echten Cashflow.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative mb-20">
          <div className="hidden lg:block absolute top-[45px] left-[15%] right-[15%] h-[2px] bg-gold/20 z-0"></div>
          {pillars.map((pillar, index) => (
            <FadeIn key={index} delay={index * 0.15} className="relative z-10">
              <div className="flex flex-col items-center text-center">
                <div className="w-20 h-20 rounded-full bg-navy border-2 border-gold flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,175,55,0.2)]">
                  <SafeIcon icon={pillar.icon} className="text-3xl text-gold" />
                </div>
                <h3 className="font-serif text-xl font-bold mb-1">{pillar.title}</h3>
                <span className="font-sans text-gold text-xs uppercase tracking-widest mb-3 block">{pillar.subtitle}</span>
                <p className="font-sans text-gray-300 text-sm leading-relaxed">{pillar.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>

        <div className="w-full h-px bg-gold/20 mb-20"></div>

        <FadeIn className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="font-serif text-2xl md:text-4xl font-bold mb-5 leading-tight">
            Warum <span className="text-gold italic">"Der Dividenden-Investor"</span> Ihr letztes Buch über Finanzen sein wird:
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto"></div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto mb-12">
          {bullets.map((item, index) => (
            <FadeIn key={index} delay={index * 0.08} direction="up">
              <div className="flex items-start gap-4 bg-white/5 border border-gold/15 rounded-2xl p-5 hover:bg-white/10 hover:border-gold/30 transition-all duration-300">
                <div className="flex-shrink-0 w-11 h-11 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center">
                  <SafeIcon icon={item.icon} className="text-lg text-gold" />
                </div>
                <div>
                  <h4 className="font-serif text-base font-bold text-white mb-1">{item.title}</h4>
                  <p className="font-sans text-gray-300 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>

        <FadeIn direction="up" delay={0.2}>
          <div className="text-center pb-6 md:pb-0">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer sponsored"
              onClick={handleAmazonClick}
              data-action="amazon-click"
              data-source="solution_section"
              className="inline-block px-8 py-4 text-navy bg-gold font-sans font-bold text-base rounded transition-all duration-300 shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:shadow-[0_0_45px_rgba(212,175,55,0.65)] hover:scale-105 hover:brightness-110"
            >
              Jetzt die Cashflow-Strategie auf Amazon sichern
            </a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};